var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.499634,
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F4EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7004 9.49963H11.8004C11.4291 9.49963 11.073 9.64713 10.8104 9.90968C10.5479 10.1722 10.4004 10.5283 10.4004 10.8996V22.0996C10.4004 22.4709 10.5479 22.827 10.8104 23.0895C11.073 23.3521 11.4291 23.4996 11.8004 23.4996H20.2003C20.5716 23.4996 20.9277 23.3521 21.1903 23.0895C21.4528 22.827 21.6003 22.4709 21.6003 22.0996V14.3996L16.7004 9.49963Z",
    stroke: "#7434DB",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7002 9.49963V14.3996H21.6002",
    stroke: "#7434DB",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/upload_file_icon.b5e5cb86bd9469c8d72f47b397e5c1ea.svg";
export { ForwardRef as ReactComponent };